import {LeftOutlined} from '@ant-design/icons'
import {Button} from 'antd'
import {listQuestion, Question} from 'api/question'
import {ObsKeyToURL} from 'api/utils'
import React, {useEffect, useRef, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import checked from './checked.png'

const getTestName = id => {
  switch (parseInt(id)) {
    case 1:
      return '初级'
    case 2:
      return '中级'
    case 3:
      return '高级'
    default:
      return '未知'
  }
}

interface Result {
  paper: Scores
  my: Scores
}

interface Scores {
  total: number
  ai_score: number // AI概念
  calc_score: number // 计算思维
  inte_score: number //智能意识
  inno_score: number // 探究创新
  soc_score: number // 智能社会责任
}

const EvaluationPaperPage = () => {
  const history = useHistory()
  const {id} = useParams<{id: string}>()
  const [questions, setQuestions] = useState<Question[]>([])
  const questionsRef = useRef<Question[]>()
  questionsRef.current = questions

  // 判断提交
  const submit = () => {
    // 计算分数
    let r: Result = {
      paper: {
        total: 0,
        ai_score: 0, // AI概念
        calc_score: 0, // 计算思维
        inte_score: 0, //智能意识
        inno_score: 0, // 探究创新
        soc_score: 0, // 智能社会责任
      },
      my: {
        total: 0,
        ai_score: 0, // AI概念
        calc_score: 0, // 计算思维
        inte_score: 0, //智能意识
        inno_score: 0, // 探究创新
        soc_score: 0, // 智能社会责任
      },
    }

    questions.forEach(q => {
      r.paper.total += q.score
      r.paper.ai_score += (q.score * q.ai_score) / 100
      r.paper.calc_score += (q.score * q.calc_score) / 100
      r.paper.inte_score += (q.score * q.inte_score) / 100
      r.paper.inno_score += (q.score * q.inno_score) / 100
      r.paper.soc_score += (q.score * q.soc_score) / 100
      console.log(q.answer, JSON.stringify(q.myAnswer))

      if (q.answer === JSON.stringify(q.myAnswer)) {
        // 正确
        r.my.total += q.score
        r.my.ai_score += (q.score * q.ai_score) / 100
        r.my.calc_score += (q.score * q.calc_score) / 100
        r.my.inte_score += (q.score * q.inte_score) / 100
        r.my.inno_score += (q.score * q.inno_score) / 100
        r.my.soc_score += (q.score * q.soc_score) / 100
      }
    })

    history.push('/evaluation/result', {
      result: r,
      title: getTestName(id),
    })

    console.log(r)
  }

  const check = (qID, aID, qType) => {
    let q = questions[qID]

    // 单选题
    if (qType === 1) {
      if (q.myAnswer && q.myAnswer[0] === aID) {
        q.myAnswer = []
      } else {
        q.myAnswer = [aID]
      }
      setQuestions([...questions])
    } else {
      // 多选题
      if (!q.myAnswer) {
        q.myAnswer = [aID]
        setQuestions([...questions])
        return
      }

      let idx = q.myAnswer.indexOf(aID)
      if (idx >= 0) {
        // 存在
        q.myAnswer.splice(idx, 1)
      } else {
        q.myAnswer.push(aID)
        q.myAnswer = q.myAnswer.sort()
      }
      setQuestions([...questions])
    }
  }

  const storeResult = () => {
    console.log('store result ', JSON.stringify(questions))

    sessionStorage.setItem('paper' + id, JSON.stringify(questionsRef.current))
  }

  const recoverResult = () => {
    console.log('check recover')

    const st = sessionStorage.getItem('paper' + id)
    if (st) {
      setQuestions(JSON.parse(st))
      return true
    }
    return false
  }

  useEffect(() => {
    window.addEventListener('beforeunload', storeResult)

    if (recoverResult()) {
      console.log('get result')

      return
    }

    console.log('get path id', id)
    // 获取数据库中的试题
    listQuestion(parseInt(id)).then(res => {
      console.log(res.data)
      let its = res.data.items
      if (its) {
        let currentType = 0
        its.forEach(element => {
          element.key = element.id
          if (element.type !== currentType) {
            element.showType = true
            currentType = element.type
          }
        })
        setQuestions(its)
      } else {
        setQuestions([])
      }
    })
  }, [])
  return (
    <>
      <div
        style={{
          margin: '0 auto',
          width: 1200,
          height: '100%',
          padding: 24,
          backgroundColor: '#ffffff',
        }}
      >
        <Button
          icon={<LeftOutlined />}
          size="large"
          onClick={() => {
            history.push('/evaluation')
          }}
        >
          返回评测页面
        </Button>
        <div
          style={{
            textAlign: 'center',
            // fontFamily: 'Source Han Sans CN',
            fontSize: 32,
            lineHeight: 1.5,
            marginTop: 16,
            marginBottom: 16,
            color: 'rgba(38,38,38,1)',
            fontWeight: 500,
          }}
        >
          AI素养水平测试({getTestName(id)})
        </div>

        <div>
          {questions.map((q, index) => (
            <div key={index + 'q'} style={{color: '#262626'}}>
              {q.showType ? (
                <div
                  style={{
                    fontSize: 24,
                    lineHeight: 1.5,
                    marginBottom: 24,
                    fontWeight: 600,
                    textAlign: 'center',
                  }}
                >
                  {q.type === 1 ? '单选题' : '多选题'}
                </div>
              ) : null}
              <div
                style={{marginBottom: 8, fontSize: 14, lineHeight: 1.5, fontWeight: 600}}
                id={index + 'q'}
              >
                {index + 1}、 {q.desc} ({q.score}分){' '}
                <span style={{color: 'red'}}>{q.hasAnswer ? '' : '*'}</span>
              </div>
              {q.image ? (
                <img
                  src={ObsKeyToURL(q.image)}
                  style={{height: 160, marginBottom: 8, marginLeft: 20}}
                  alt="qi"
                />
              ) : null}

              {/* 选项A */}
              <div
                key={index + 'qa'}
                className={`question-option ${
                  q.myAnswer?.includes(0) ? 'question-option-checked' : ''
                }`}
                onClick={() => check(index, 0, q.type)}
              >
                <span>A. {q.a}</span>{' '}
                {q.myAnswer?.includes(0) ? (
                  <span>
                    <img src={checked} alt="check" />
                  </span>
                ) : null}
              </div>
              {/* 选项B */}
              <div
                className={`question-option ${
                  q.myAnswer?.includes(1) ? 'question-option-checked' : ''
                }`}
                onClick={() => check(index, 1, q.type)}
              >
                <span>B. {q.b}</span>{' '}
                {q.myAnswer?.includes(1) ? (
                  <span>
                    <img src={checked} alt="check" />
                  </span>
                ) : null}
              </div>
              {/* 选项C */}
              <div
                className={`question-option ${
                  q.myAnswer?.includes(2) ? 'question-option-checked' : ''
                }`}
                onClick={() => check(index, 2, q.type)}
              >
                <span>C. {q.c}</span>{' '}
                {q.myAnswer?.includes(2) ? (
                  <span>
                    <img src={checked} alt="check" />
                  </span>
                ) : null}
              </div>
              {/* 选项D */}
              <div
                className={`question-option ${
                  q.myAnswer?.includes(3) ? 'question-option-checked' : ''
                }`}
                onClick={() => check(index, 3, q.type)}
              >
                <span>D. {q.d}</span>{' '}
                {q.myAnswer?.includes(3) ? (
                  <span>
                    <img src={checked} alt="check" />
                  </span>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        style={{
          position: 'fixed',
          right: 120,
          bottom: 200,
          padding: 8,
          maxWidth: 190,
          background: 'white',
          boxShadow: '0px 4px 8px rgba(0,0,0,0.08)',
          borderRadius: 8,
        }}
      >
        <div style={{fontSize: 16, fontWeight: 600, textAlign: 'center', marginBottom: 12}}>
          答题卡
        </div>
        <div style={{display: 'flex', flexWrap: 'wrap'}}>
          {questions.map((q, index) => (
            <div
              key={index + 'qi'}
              onClick={() => {
                document.getElementById(index + 'q')?.scrollIntoView({
                  behavior: 'smooth',
                })
              }}
              style={{
                width: 40,
                height: 40,
                borderRadius: 4,
                marginRight: 2,
                marginBottom: 2,
                border: '1px solid #f5f5f5',
                textAlign: 'center',
                lineHeight: '40px',
                cursor: 'pointer',
              }}
              className={`answer-block ${
                q.myAnswer && q.myAnswer.length > 0 ? 'answer-block-active' : ''
              }`}
            >
              {index + 1}
            </div>
          ))}
        </div>

        <div style={{textAlign: 'center', marginTop: 24}}>
          <Button type="primary" onClick={submit}>
            提交
          </Button>
        </div>
      </div>
    </>
  )
}

export default EvaluationPaperPage
